/*import { useNavigate } from "react-router-dom";

function EntryList({ entries }) {
  const navigate = useNavigate();

  if (!entries.length) {
    return <p style={{ color: "#b8c5d6", fontStyle: "italic" }}>No entries yet. Create your first one!</p>;
  }

  // Group entries by session_root_id, preserving display order (first entry of each group)
  const sessionMap = new Map();
  entries.forEach(entry => {
    const rootId = entry.session_root_id ?? entry.id;
    if (!sessionMap.has(rootId)) {
      sessionMap.set(rootId, []);
    }
    sessionMap.get(rootId).push(entry);
  });

  const groups = Array.from(sessionMap.values());
  console.log('Entry groups (groups var):', groups);
  const STATE_ORDER = ['Before', 'During', 'After', 'Integration'];



   const getFirstLine = (entry, maxLen = 60) => {
  const raw = (entry.title ?? entry.content ?? entry.text ?? entry.body ?? '').toString().trim();
  if (!raw) return '';

  // take the first non-empty line (useful if title contains newlines)
  const lines = raw.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
  const first = lines.length ? lines[0] : raw;

  // normalize internal whitespace
  const normalized = first.replace(/\s+/g, ' ');

  // if short enough, return as-is
  if (normalized.length <= maxLen) return normalized;

  // hard truncate then try to avoid cutting mid-word
  const truncated = normalized.slice(0, maxLen);
  const lastSpace = truncated.lastIndexOf(' ');
  if (lastSpace > Math.floor(maxLen * 0.6)) {
    return truncated.slice(0, lastSpace) + '…';
  }
  return truncated + '…';
};

  // helper: compute relative time like "2 days ago"
  const timeAgo = (iso) => {
    if (!iso) return 'unknown';
    const then = new Date(iso).getTime();
    const now = Date.now();
    const diff = Math.max(0, now - then);
    const sec = Math.floor(diff / 1000);
    const min = Math.floor(sec / 60);
    const hr  = Math.floor(min / 60);
    const day = Math.floor(hr / 24);
    if (day >= 2) return `${day} days ago`;
    if (day === 1) return '1 day ago';
    if (hr >= 1) return `${hr} hour${hr === 1 ? '' : 's'} ago`;
    if (min >= 1) return `${min} minute${min === 1 ? '' : 's'} ago`;
    return 'just now';
  };

  const statePill = (state, isLogged) => {
    const colors = {
      Before:      { bg: 'rgba(255,255,255,0.07)',       border: 'rgba(255,255,255,0.15)',      text: 'rgba(255,255,255,0.5)'  },
      During:      { bg: 'rgba(255,211,80,0.1)',          border: 'rgba(255,211,80,0.25)',        text: '#ffd350'                },
      After:       { bg: 'rgba(125,211,132,0.1)',         border: 'rgba(125,211,132,0.25)',       text: '#7dd384'                },
      Integration: { bg: 'rgba(180,125,232,0.1)',         border: 'rgba(180,125,232,0.25)',       text: '#b47de8'                },
    };
    const c = colors[state] || colors.Before;
    return (
      <span
        key={state}
        style={{
          fontSize: '11px',
          padding: '2px 8px',
          borderRadius: '12px',
          background: isLogged ? c.bg : 'transparent',
          border: `1px solid ${isLogged ? c.border : 'rgba(255,255,255,0.08)'}`,
          color: isLogged ? c.text : 'rgba(255,255,255,0.2)',
          fontStyle: isLogged ? 'normal' : 'italic',
        }}
      >
        {state}
      </span>
    );
  };



  return (
    <div className="EntryList">
      {groups.map(group => {
        const root = group.find(e => !e.session_id) || group[0];
        const isMulti = group.length > 1;
        const isMushroom = root.medicine_type === 'mushroom';
        const accentColor = isMushroom ? 'rgba(180,125,232,0.4)' : 'rgba(125,211,232,0.4)';
        const loggedStates = new Set(group.map(e => e.state));

        const dateStr = new Date(root.session_date)
          .toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });

        // Aggregate mood across the session
        const moodBefore = group.find(e => e.mood_before)?.mood_before;
        const moodAfter  = [...group].reverse().find(e => e.mood_after)?.mood_after;

        


  // find most recent timestamp in the group for "last X ago"
  const mostRecentTs = group.reduce((acc, e) => {
    const t = new Date(e.created_at || e.session_date || 0).getTime();
    return Math.max(acc, t);
  }, 0);
  const lastUpdatedRelative = mostRecentTs ? timeAgo(new Date(mostRecentTs).toISOString()) : 'unknown';

  // sort group by created_at descending and take most recent two (display most recent first)
  const sorted = [...group].sort((a, b) => {
    const ta = new Date(a.created_at || a.session_date || 0).getTime();
    const tb = new Date(b.created_at || b.session_date || 0).getTime();
    return tb - ta;
  });
  const snippets = sorted.slice(0, 2);

  // ── Grouped session card (mockup-accurate) ─────────────────────────────
  return (
    <article
      key={root.id}
      onClick={() => navigate(`/session/${root.id}`)}
      style={{
        padding: '14px 20px',
        marginBottom: '12px',
        background: 'rgba(255,255,255,0.05)',
        borderRadius: '10px',
        borderLeft: `3px solid ${accentColor}`,
        cursor: 'pointer',
        transition: 'background 0.15s, transform 120ms',
      }}
      onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}
      onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate(`/session/${root.id}`); }}
      tabIndex={0}
      role="group"
      aria-label={`${root.subcategory || 'Untitled Session'}, ${group.length} entries, last updated ${lastUpdatedRelative}`}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <span style={{ fontSize: '12px', opacity: 0.6 }}>{dateStr}</span>
        {(moodBefore || moodAfter) && (
          <span style={{ fontSize: '12px', opacity: 0.7 }}>
            {moodBefore ? `😶 ${moodBefore}` : ''}
            {moodBefore && moodAfter ? ' → ' : ''}
            {moodAfter  ? `😊 ${moodAfter}`  : ''}
          </span>
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
        <span style={{ fontSize: '15px' }}>{isMushroom ? '🍄' : '🌿'}</span>
        <h3 style={{
          margin: 0,
          fontSize: '16px',
          fontWeight: '500',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {root.subcategory || 'Untitled Session'}
        </h3>
      <div style={{ color: '#b8c5d6', fontSize: '12px', marginLeft: 'auto' }}>
        {group.length} entries · last {lastUpdatedRelative}
      </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '8px', marginLeft: '36px' }}>
        {snippets.length ? snippets.map(entry => {
          const firstLine = ' 📓 ' + getFirstLine(entry) || '(no text)';
          return (
            <div
              key={entry.id}
              style={{
                color: 'rgba(255,255,255,0.9)',
                fontSize: '14px',
                opacity: 0.65,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                lineHeight: '1.2',
                userSelect: 'text',
                marginLeft: 0, // already indented by container
              }}
              aria-hidden="false"
            >
              {firstLine}..
            </div>
          );
        }) : (
          <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: '14px', marginLeft: '26px' }}>No entries yet</div>
        )}
      </div>

     

      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '8px' }}>
        {STATE_ORDER.map(s => statePill(s, loggedStates.has(s)))}
      </div>
    </article>
  );
}


        // ── Single entry card ───────────────────
        const entry = group[0];
        return (
          <article
            key={entry.id}
            style={{
              padding: '16px 20px',
              marginBottom: '12px',
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '10px',
              borderLeft: `3px solid ${accentColor}`,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
              <span style={{ fontSize: '12px', opacity: 0.6 }}>
                {new Date(entry.session_date).toLocaleDateString('en-US', { timeZone: 'UTC' })}
              </span>
              {(entry.mood_before || entry.mood_after) && (
                <span style={{ fontSize: '12px', opacity: 0.7 }}>
                  {entry.mood_before ? `😶 ${entry.mood_before}` : ''}
                  {entry.mood_before && entry.mood_after ? ' → ' : ''}
                  {entry.mood_after  ? `😊 ${entry.mood_after}`  : ''}
                </span>
              )}
            </div>

            <h3 style={{ margin: '0 0 6px 0', fontSize: '16px' }}>
              <span
                onClick={() => navigate(`/entry/${entry.id}`)}
                style={{ cursor: 'pointer', color: '#7dd3e8', textDecoration: 'underline' }}
              >
                {entry.title || 'Untitled'}
              </span>
            </h3>

            {(entry.subcategory || entry.state || entry.category) && (
              <p style={{ fontSize: '12px', opacity: 0.6, margin: '0 0 8px 0' }}>
                {[entry.subcategory, entry.state, entry.category].filter(Boolean).join(' · ')}
              </p>
            )}

            {entry.content && (
              <p style={{ fontSize: '13px', opacity: 0.8, margin: 0, fontStyle: 'italic' }}>
                {entry.content.slice(0, 120)}{entry.content.length > 120 ? '…' : ''}
              </p>
            )}
          </article>
        );
      })}
    </div>
  );
}

export default EntryList;
*/
/*
import { useNavigate } from "react-router-dom";

function EntryList({ entries }) {
  const navigate = useNavigate();

  if (!entries.length) {
    return <p style={{ color: "#b8c5d6", fontStyle: "italic" }}>No entries yet. Create your first one!</p>;
  }

  const getGroupKey = (entry) => {
  console.log('Grouping entry:', entry);
  return entry.session_root_id != null
    ? `session:${entry.session_root_id}`
    : `entry:${entry.id}`;
};

  const sessionMap = new Map();
  entries.forEach((entry) => {
    const key = getGroupKey(entry);
    if (!sessionMap.has(key)) sessionMap.set(key, []);
      sessionMap.get(key).push(entry);
  });

  const groups = Array.from(sessionMap.values());
  const STATE_ORDER = ['Before', 'During', 'After', 'Integration'];

  const getFirstLine = (entry, maxLen = 60) => {
    const raw = (entry.title ?? entry.content ?? entry.text ?? entry.body ?? '')
      .toString()
      .trim();

    if (!raw) return '';

    const lines = raw.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
    const first = lines.length ? lines[0] : raw;

    const normalized = first.replace(/\s+/g, ' ');

    if (normalized.length <= maxLen) return normalized;

    const truncated = normalized.slice(0, maxLen);
    const lastSpace = truncated.lastIndexOf(' ');

    if (lastSpace > Math.floor(maxLen * 0.6)) {
      return truncated.slice(0, lastSpace) + '…';
    }

    return truncated + '…';
  };

  const timeAgo = (iso) => {
    if (!iso) return 'unknown';
    const then = new Date(iso).getTime();
    const now = Date.now();
    const diff = Math.max(0, now - then);
    const sec = Math.floor(diff / 1000);
    const min = Math.floor(sec / 60);
    const hr  = Math.floor(min / 60);
    const day = Math.floor(hr / 24);

    if (day >= 2) return `${day} days ago`;
    if (day === 1) return '1 day ago';
    if (hr >= 1) return `${hr} hour${hr === 1 ? '' : 's'} ago`;
    if (min >= 1) return `${min} minute${min === 1 ? '' : 's'} ago`;
    return 'just now';
  };

  const statePill = (state, isLogged) => {
    const colors = {
      Before:      { bg: 'rgba(255,255,255,0.07)', border: 'rgba(255,255,255,0.15)', text: 'rgba(255,255,255,0.5)' },
      During:      { bg: 'rgba(255,211,80,0.1)', border: 'rgba(255,211,80,0.25)', text: '#ffd350' },
      After:       { bg: 'rgba(125,211,132,0.1)', border: 'rgba(125,211,132,0.25)', text: '#7dd384' },
      Integration: { bg: 'rgba(180,125,232,0.1)', border: 'rgba(180,125,232,0.25)', text: '#b47de8' },
    };

    const c = colors[state] || colors.Before;

    return (
      <span
        key={state}
        style={{
          fontSize: '11px',
          padding: '2px 8px',
          borderRadius: '12px',
          background: isLogged ? c.bg : 'transparent',
          border: `1px solid ${isLogged ? c.border : 'rgba(255,255,255,0.08)'}`,
          color: isLogged ? c.text : 'rgba(255,255,255,0.2)',
          fontStyle: isLogged ? 'normal' : 'italic',
        }}
      >
        {state}
      </span>
    );
  };

  return (
    <div className="EntryList">
      {groups.map(group => {
        const root = group.find(e => !e.session_id) || group[0];
        const isMushroom = root.medicine_type === 'mushroom';
        const accentColor = isMushroom
          ? 'rgba(180,125,232,0.4)'
          : 'rgba(125,211,232,0.4)';

        const loggedStates = new Set(group.map(e => e.state));

        const dateStr = new Date(root.session_date)
          .toLocaleDateString('en-US', {
            timeZone: 'UTC',
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          });

        const moodBefore = group.find(e => e.mood_before)?.mood_before;
        const moodAfter = [...group].reverse().find(e => e.mood_after)?.mood_after;

        const mostRecentTs = group.reduce((acc, e) => {
          const t = new Date(e.created_at || e.session_date || 0).getTime();
          return Math.max(acc, t);
        }, 0);

        const lastUpdatedRelative = mostRecentTs
          ? timeAgo(new Date(mostRecentTs).toISOString())
          : 'unknown';

        const sorted = [...group].sort((a, b) => {
          const ta = new Date(a.created_at || a.session_date || 0).getTime();
          const tb = new Date(b.created_at || b.session_date || 0).getTime();
          return tb - ta;
        });

        const snippets = sorted.slice(0, 2);

        return (
          <article
            key={root.id}
            onClick={() => navigate(`/session/${root.id}`)}
            style={{
              padding: '14px 20px',
              marginBottom: '12px',
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '10px',
              borderLeft: `3px solid ${accentColor}`,
              cursor: 'pointer',
              transition: 'background 0.15s, transform 120ms',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <span style={{ fontSize: '12px', opacity: 0.6 }}>{dateStr}</span>

              {(moodBefore || moodAfter) && (
                <span style={{ fontSize: '12px', opacity: 0.7 }}>
                  {moodBefore ? `😶 ${moodBefore}` : ''}
                  {moodBefore && moodAfter ? ' → ' : ''}
                  {moodAfter ? `😊 ${moodAfter}` : ''}
                </span>
              )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
              <span style={{ fontSize: '15px' }}>{isMushroom ? '🍄' : '🌿'}</span>

              <h3 style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {root.subcategory || 'Untitled Session'}
              </h3>

              <div style={{ color: '#b8c5d6', fontSize: '12px', marginLeft: 'auto' }}>
                {group.length} entries · last {lastUpdatedRelative}
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '8px', marginLeft: '36px' }}>
              {snippets.length ? snippets.map(entry => (
                <div
                  key={entry.id}
                  style={{
                    color: 'rgba(255,255,255,0.9)',
                    fontSize: '14px',
                    opacity: 0.65,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: '1.2',
                  }}
                >
                  📓 {getFirstLine(entry)}
                </div>
              )) : (
                <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: '14px', marginLeft: '26px' }}>
                  No entries yet
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '8px' }}>
              {STATE_ORDER.map(s => statePill(s, loggedStates.has(s)))}
            </div>
          </article>
        );
      })}
    </div>
  );
}

export default EntryList;
*/
import { useNavigate } from "react-router-dom";

function EntryList({ entries }) {
  const navigate = useNavigate();

  if (!entries.length) {
    return <p style={{ color: "#b8c5d6", fontStyle: "italic" }}>No entries yet. Create your first one!</p>;
  }

  const getGroupKey = (entry) => {
    return entry.session_root_id != null
      ? `session:${entry.session_root_id}`
      : `entry:${entry.id}`;
  };

  const sessionMap = new Map();
  entries.forEach((entry) => {
    const key = getGroupKey(entry);
    if (!sessionMap.has(key)) sessionMap.set(key, []);
    sessionMap.get(key).push(entry);
  });

  const groups = Array.from(sessionMap.values());
  const STATE_ORDER = ["Before", "During", "After", "Integration"];

  const getFirstLine = (entry, maxLen = 60) => {
    const raw = (entry.title ?? entry.content ?? entry.text ?? entry.body ?? "")
      .toString()
      .trim();

    if (!raw) return "";

    const lines = raw.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
    const first = lines.length ? lines[0] : raw;
    const normalized = first.replace(/\s+/g, " ");

    if (normalized.length <= maxLen) return normalized;

    const truncated = normalized.slice(0, maxLen);
    const lastSpace = truncated.lastIndexOf(" ");
    if (lastSpace > Math.floor(maxLen * 0.6)) {
      return truncated.slice(0, lastSpace) + "…";
    }

    return truncated + "…";
  };

  const timeAgo = (iso) => {
    if (!iso) return "unknown";
    const then = new Date(iso).getTime();
    const now = Date.now();
    const diff = Math.max(0, now - then);
    const min = Math.floor(diff / 1000 / 60);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);

    if (day >= 2) return `${day} days ago`;
    if (day === 1) return "1 day ago";
    if (hr >= 1) return `${hr} hour${hr === 1 ? "" : "s"} ago`;
    if (min >= 1) return `${min} minute${min === 1 ? "" : "s"} ago`;
    return "just now";
  };

  const statePill = (state, isLogged) => {
    const colors = {
      Before: { bg: "rgba(255,255,255,0.07)", border: "rgba(255,255,255,0.15)", text: "rgba(255,255,255,0.5)" },
      During: { bg: "rgba(255,211,80,0.1)", border: "rgba(255,211,80,0.25)", text: "#ffd350" },
      After: { bg: "rgba(125,211,132,0.1)", border: "rgba(125,211,132,0.25)", text: "#7dd384" },
      Integration: { bg: "rgba(180,125,232,0.1)", border: "rgba(180,125,232,0.25)", text: "#b47de8" },
    };

    const c = colors[state] || colors.Before;

    return (
      <span
        key={state}
        style={{
          fontSize: "11px",
          padding: "2px 8px",
          borderRadius: "12px",
          background: isLogged ? c.bg : "transparent",
          border: `1px solid ${isLogged ? c.border : "rgba(255,255,255,0.08)"}`,
          color: isLogged ? c.text : "rgba(255,255,255,0.2)",
          fontStyle: isLogged ? "normal" : "italic",
        }}
      >
        {state}
      </span>
    );
  };

  return (
    <div className="EntryList">
      {groups.map((group) => {
        const root = group.find((e) => !e.session_id) || group[0];
        const isMushroom = root.medicine_type === "mushroom";
        const accentColor = isMushroom ? "rgba(180,125,232,0.4)" : "rgba(125,211,232,0.4)";
        const loggedStates = new Set(group.map((e) => e.state));

        const dateStr = new Date(root.session_date).toLocaleDateString("en-US", {
          timeZone: "UTC",
          month: "short",
          day: "numeric",
          year: "numeric",
        });

        const moodBefore = group.find((e) => e.mood_before)?.mood_before;
        const moodAfter = [...group].reverse().find((e) => e.mood_after)?.mood_after;

        const mostRecentTs = group.reduce((acc, e) => {
          const t = new Date(e.created_at || e.session_date || 0).getTime();
          return Math.max(acc, t);
        }, 0);

        const lastUpdatedRelative = mostRecentTs
          ? timeAgo(new Date(mostRecentTs).toISOString())
          : "unknown";

        const sorted = [...group].sort((a, b) => {
          const ta = new Date(a.created_at || a.session_date || 0).getTime();
          const tb = new Date(b.created_at || b.session_date || 0).getTime();
          return tb - ta;
        });

        const snippets = sorted.slice(0, 2);

        if (group.length === 1) {
          const entry = group[0];

          return (
            <article
              key={entry.id}
              style={{
                padding: "16px 20px",
                marginBottom: "12px",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "10px",
                borderLeft: `3px solid ${accentColor}`,
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                <span style={{ fontSize: "12px", opacity: 0.6 }}>
                  {new Date(entry.session_date).toLocaleDateString("en-US", { timeZone: "UTC" })}
                </span>

                {(entry.mood_before || entry.mood_after) && (
                  <span style={{ fontSize: "12px", opacity: 0.7 }}>
                    {entry.mood_before ? `😶 ${entry.mood_before}` : ""}
                    {entry.mood_before && entry.mood_after ? " → " : ""}
                    {entry.mood_after ? `😊 ${entry.mood_after}` : ""}
                  </span>
                )}
              </div>

              <h3 style={{ margin: "0 0 6px 0", fontSize: "16px" }}>
                <span
                  onClick={() => navigate(`/entry/${entry.id}`)}
                  style={{ cursor: "pointer", color: "#7dd3e8", textDecoration: "underline" }}
                >
                  {entry.title || "Untitled"}
                </span>
              </h3>

              {(entry.subcategory || entry.state || entry.category) && (
                <p style={{ fontSize: "12px", opacity: 0.6, margin: "0 0 8px 0" }}>
                  {[entry.subcategory, entry.state, entry.category].filter(Boolean).join(" · ")}
                </p>
              )}

              {entry.content && (
                <p style={{ fontSize: "13px", opacity: 0.8, margin: 0, fontStyle: "italic" }}>
                  {entry.content.slice(0, 120)}
                  {entry.content.length > 120 ? "…" : ""}
                </p>
              )}
            </article>
          );
        }

        return (
          <article
            key={root.id}
            onClick={() => navigate(`/session/${root.id}`)}
            style={{
              padding: "14px 20px",
              marginBottom: "12px",
              background: "rgba(255,255,255,0.05)",
              borderRadius: "10px",
              borderLeft: `3px solid ${accentColor}`,
              cursor: "pointer",
              transition: "background 0.15s, transform 120ms",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
              <span style={{ fontSize: "12px", opacity: 0.7 }}>Chapter: {dateStr}</span>

              {(moodBefore || moodAfter) && (
                <span style={{ fontSize: "12px", opacity: 0.7 }}>
                  {moodBefore ? `😶 ${moodBefore}` : ""}
                  {moodBefore && moodAfter ? " → " : ""}
                  {moodAfter ? `😊 ${moodAfter}` : ""}
                </span>
              )}
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
              <span style={{ fontSize: "15px" }}>{isMushroom ? "🌀" : "🌿"}</span>

              <h3
                style={{
                  margin: 0,
                  fontSize: "16px",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {root.subcategory || "Untitled Session"}
              </h3>

              <div style={{ color: "#b8c5d6", fontSize: "12px", marginLeft: "auto" }}>
                {group.length} entries · last {lastUpdatedRelative}
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "8px", marginLeft: "36px" }}>
              {snippets.length ? (
                snippets.map((entry) => (
                  <div
                    key={entry.id}
                    style={{
                      color: "rgba(255,255,255,0.9)",
                      fontSize: "14px",
                      opacity: 0.65,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      lineHeight: "1.2",
                    }}
                  >
                    📓 {getFirstLine(entry)}
                  </div>
                ))
              ) : (
                <div style={{ color: "rgba(255,255,255,0.45)", fontSize: "14px", marginLeft: "26px" }}>
                  No entries yet
                </div>
              )}
            </div>

            <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginTop: "8px" }}>
              {STATE_ORDER.map((s) => statePill(s, loggedStates.has(s)))}
            </div>
          </article>
        );
      })}
    </div>
  );
}

export default EntryList;